'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isBoolean = exports.isBoolean = function isBoolean(type) {
  return ['radio', 'checkbox'].indexOf(type) > -1;
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/lib/form/index.js
// module id = 153
// module chunks = 0